import { style, globalStyle } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { mobile, reducedMotion } from '@/shared/ui/theme';

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.lg,
});

export const emptyState = style({
  textAlign: 'center',
  padding: `${vars.spacing.padding.lg} 0`,
  color: vars.typography.textColor.tertiary,
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
});

export const passkeyList = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
});

export const passkeyCard = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: vars.spacing.padding.md,
  borderRadius: vars.spacing.borderRadius.md,
  background: vars.bright.card.subtle,
  border: `1px solid ${vars.surface.border.secondary}`,
  gap: vars.spacing.gap.md,
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  '@media': {
    [mobile]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const passkeyInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  flex: 1,
  minWidth: 0,
});

export const passkeyName = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.bold,
  color: vars.bright.secondary.default,
  letterSpacing: vars.typography.letterSpacing.label,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const passkeyMeta = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.tertiary,
});

export const deviceBadge = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: `2px 8px`,
  borderRadius: '12px',
  background: vars.bright.badge.secondary.background,
  border: `1px solid ${vars.bright.badge.secondary.border}`,
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.bright.secondary.default,
});

export const passkeyActions = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.xs,
  flexShrink: 0,
  '@media': {
    [mobile]: {
      alignSelf: 'flex-end',
    },
  },
});

export const iconButton = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '6px',
  borderRadius: vars.spacing.borderRadius.sm,
  color: vars.typography.textColor.tertiary,
  transition: `color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  selectors: {
    '&:hover': {
      color: vars.bright.secondary.default,
    },
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const deleteButton = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '6px',
  borderRadius: vars.spacing.borderRadius.sm,
  color: vars.typography.textColor.tertiary,
  transition: `color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  selectors: {
    '&:hover': {
      color: vars.bright.status.error,
    },
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const unsupportedNotice = style({
  textAlign: 'center',
  padding: vars.spacing.padding.lg,
  color: vars.typography.textColor.tertiary,
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
  background: vars.bright.card.subtle,
  borderRadius: vars.spacing.borderRadius.md,
  border: `1px solid ${vars.surface.border.secondary}`,
});

export const registerSection = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
});

export const nameInput = style({
  display: 'flex',
  gap: vars.spacing.gap.sm,
  alignItems: 'center',
  '@media': {
    [mobile]: {
      flexDirection: 'column',
    },
  },
});

// BUG-66/67: Input fullWidth(width:100%)가 flex row를 전부 차지하여
// Button 텍스트가 강제 축소되는 문제 방지
globalStyle(`${nameInput} > div`, {
  flex: 1,
  minWidth: 0,
});

globalStyle(`${nameInput} button`, {
  flexShrink: 0,
});

export const errorText = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.error,
  fontFamily: vars.typography.fontFamily.primary,
});
